import { render, staticRenderFns } from "./RecommendProjectToUsers.vue?vue&type=template&id=501008a8&scoped=true"
import script from "./RecommendProjectToUsers.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendProjectToUsers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RecommendProjectToUsers.vue?vue&type=style&index=0&id=501008a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501008a8",
  null
  
)

export default component.exports